import superAdminApi from "./superAdminApi";
import CommonService from "./common.service";

const isSupportManagerPortal = () =>
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/dashboard/support-manager");

const managerBase = "/support-manager/disputes";

export const disputeExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export const fetchPlatformDisputes = async (params = {}) => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.get(managerBase, params, { silent: true });
    return res?.data ?? { items: [], total: 0, page: 1, pageSize: 20 };
  }
  const res = await superAdminApi.get("/super-admin/disputes", { params });
  return res.data?.data ?? { items: [], total: 0, page: 1, pageSize: 20 };
};

export const fetchPlatformDisputeById = async (id) => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.get(`${managerBase}/${id}`, {}, { silent: true });
    return res?.data ?? { dispute: null, assignmentHistory: [] };
  }
  const res = await superAdminApi.get(`/super-admin/disputes/${id}`);
  return res.data?.data ?? { dispute: null, assignmentHistory: [] };
};

export const fetchMyAssignedSuperAdminDisputeById = async (id) => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.get(`${managerBase}/${id}`, {}, { silent: true });
    return res?.data ?? null;
  }
  const res = await superAdminApi.get(`/super-admin/disputes/${id}`);
  return res.data?.data ?? null;
};

export const updateMyAssignedSuperAdminDisputeStatus = async (id, payload) => {
  const res = await superAdminApi.patch(`/super-admin/disputes/${id}/status`, payload);
  return res.data?.data?.dispute ?? null;
};

export const postMyAssignedSuperAdminDisputeMessage = async (
  id,
  { message, isInternal, attachment },
) => {
  if (isSupportManagerPortal()) {
    if (!isInternal) {
      throw new Error("Support Managers may add internal notes but cannot message as the assigned Support User.");
    }
    const res = await CommonService.post(
      `${managerBase}/${id}/internal-notes`,
      { message },
      { silent: true },
    );
    return res?.data?.message ?? null;
  }
  const form = new FormData();
  form.append("message", message || "");
  form.append("isInternal", isInternal ? "true" : "false");
  if (attachment) form.append("attachment", attachment);
  const res = await superAdminApi.post(`/super-admin/disputes/${id}/messages`, form);
  return res.data?.data?.message ?? null;
};

export const fetchDisputeSupportUsers = async () => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.get(`${managerBase}/assignees`, {}, { silent: true });
    return res?.data?.supportUsers ?? [];
  }
  const res = await superAdminApi.get("/super-admin/disputes/support-users");
  return res.data?.data?.items ?? [];
};

export const fetchDisputeAssignees = async () => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.get(`${managerBase}/assignees`, {}, { silent: true });
    const data = res?.data ?? {};
    return {
      supportUsers: Array.isArray(data.supportUsers) ? data.supportUsers : [],
      superAdmins: [],
    };
  }
  const res = await superAdminApi.get("/super-admin/disputes/assignees");
  const data = res.data?.data ?? {};
  return {
    supportUsers: Array.isArray(data.supportUsers) ? data.supportUsers : [],
    superAdmins: Array.isArray(data.superAdmins) ? data.superAdmins : [],
  };
};

export const assignPlatformDispute = async (id, payload) => {
  if (isSupportManagerPortal()) {
    const res = await CommonService.post(
      `${managerBase}/${id}/assign`,
      { accessUserId: payload.accessUserId, notes: payload.notes },
      { silent: true },
    );
    return res?.data?.dispute ?? null;
  }
  const res = await superAdminApi.post(`/super-admin/disputes/${id}/assign`, payload);
  return res.data?.data?.dispute ?? null;
};

export const reopenManagedDispute = async (id, reason = "") => {
  if (!isSupportManagerPortal()) {
    throw new Error("Only the owning Support Manager can reopen a dispute.");
  }
  const res = await CommonService.patch(
    `${managerBase}/${id}/reopen`,
    { reason },
    { silent: true },
  );
  return res?.data?.dispute ?? null;
};
